import gql from 'graphql-tag'

export const GROUP_CHART_APP = gql`
    query($id: ID!, $token: String!) {
        chartApp(groupId: $id, token: $token)
    }
`
